
const useIsVideo = () => {
  const params = new URLSearchParams(window.location.search);
  const isVideoCallParam = params.get("isVideoCall");
  const isVideoCall = isVideoCallParam === "true"; // Convert to boolean
 return isVideoCall;
};

export default useIsVideo;
